

































































































































































import settings from '@/settings'
import Menus from '@/components/menus'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import d from '@/utils/imports'

export default {
    name: 'imports_configuration'

    components: { Menus }

    props:
        uid:
            type: String
        item:
            type: String

    data: ()->
        errors: {}
        dialog_visible: false
        db_save: false
        false: false
        connect: ''
        configuration_set: []
        selected_configuration: ''
        configuration: {
            name: ""
            ignore_lines: 1
            fields: []
        }
        min: 0
        selected_table: 1
        import_first_lines: []
        import_errors: {}
        import_warnings: {}
        log_file_dir: ''
        import_success: false
        delete_all: false
        columns_count: Object.keys(d[@item]['fields']).length
        tables_count: d[@item]['tables_count']

    computed:
        item_label: ()->
            return d[@item]['label']

        right_nav: ()->
            return @selected_table == @tables_count

        left_nav: ()->
            return @selected_table == 1

        item_fields: ()->
            ignore_obj = {"": {label: '- Ignorer la colonne -'}}
            fields_obj = Object.assign({}, ignore_obj, d[@item]['fields'])
            return fields_obj

        company_uid: ()->
            # console.log "GETTERS IMPORT", @$store.state.selected_company.uid
            return @$store.state.selected_company.uid

    methods:
        back: ()->
            @$router.push({name:"imports_upload", params:{item:@item}})
            return

        cancel: ()->
            self = @
            # console.log "CANCEL"
            if !@db_save
                @$confirm("Ne souhaitez-vous pas importer vos données ?", 'Confirmation', {
                    confirmButtonText: 'Non'
                    cancelButtonText: 'Importer',
                    })
                    .then ()->
                        self.dialog_visible = false
                    .catch (cancel)->
                        return
            else
                @dialog_visible = false
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        reset_configuration: ()->
            @configuration = {
                name: ""
                ignore_lines: 1
                fields: []
            }
            return

        buttons_disabled: ()->
            if @selected_configuration == ''
                return true
            return false

        configuration_fields_factory: ()->
            for f in Object.keys(d[@item]['fields'])
                @configuration.fields.push(f)
            if Object.keys(d[@item]['fields']).length < @columns_count
                sup_fields = @columns_count - Object.keys(d[@item]['fields']).length
                for s in [1..sup_fields]
                    @configuration.fields.push("")
            # console.log "CONFIGURATION FIELDS FACTORY ", @configuration.fields
            return

        column_label: (col_number)->
            # console.log "FIELDS LABEL ", col_number
            return Object.values(d[@item]['fields'])[col_number-1]['label']

        columns_numbers: (index)->
            end = index * 6
            start = end - 5
            if end > @columns_count
                end = @columns_count
            # console.log "FIELDS NUMBER ", [start..end]
            return [start..end]

        displayed_columns: ()->
            end = @selected_table * 6
            start = end - 5
            if end > @columns_count
                end = @columns_count
            return start+' - '+end

        change_table: (side)->
            if side == 'right' and @selected_table < @tables_count
                @selected_table += 1
            else if side == 'left' and @selected_table > 1
                @selected_table -= 1
            # console.log "CHANGE TABLE", @selected_table
            return

        download_file: ()->
            url = settings.media_url+@log_file_dir
            filename = 'journal_d_erreurs_import.txt'
            t.download_file(url, filename)
            return

        load_configuration: ()->
            # console.log "LOAD CONFIGURATION selected config uid : ", @selected_configuration
            # console.log "LOAD CONFIGURATION fields : ", @configuration.fields
            # console.log "LOAD CONFIGURATION configuration set fields : ", @configuration_set[@selected_configuration]['fields']
            tmp_array = @configuration_set[@selected_configuration]['fields'].split(',')
            @configuration.fields = []
            for f in tmp_array
                # console.log "LOAD FOR ", f == "", f
                if f != ""
                    @configuration.fields.push(f)
                else
                    @configuration.fields.push("")
            if tmp_array.length < @columns_count
                sup_fields = @columns_count - tmp_array.length
                for s in [1..sup_fields]
                    @configuration.fields.push("")
            # console.log "LOAD CONFIGURATION fields again : ", @configuration.fields
            return

        delete_configuration: ()->
            # console.log "DELETE IMPORT CONFIGURATION", @configuration_set[@selected_configuration]['uid']
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette configuration d'import ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "IMPORT CONFIGURATION DELETE"
                    m.run('delete_object', ['import_configuration', self.configuration_set[self.selected_configuration]['uid']])
                    .then (resp)->
                        # console.log "DELETE IMPORT CONFIGURATION", resp.body.data.import_configuration_deletion
                        if resp.body.data.import_configuration_deletion.ok
                            n.success()
                            self.selected_configuration = ''
                            self.reset_configuration()
                            self.configuration_fields_factory()
                            self.get_import_configurations()
                        else
                            n.gql_error("imports_configuration: delete_configuration: then", resp.body.data.import_configuration_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "imports_configuration: delete_configuration()")
                .catch (cancel)->
                    return

        save_configuration: ()->
            # console.log "SAVE"
            for f of d[@item]['fields']
                index = @configuration.fields.indexOf(f)
                if @configuration.fields.indexOf(f, index+1) > -1
                    n.error('Tableau des données', 'Deux colonnes ne peuvent avoir le même nom')
                    return    
            self = @
            @configuration.company_uid = @company_uid
            @configuration.item = @item

            # console.log "SAVE 2 ", @configuration
            m.run('save_import_configuration', [@configuration])
            .then (resp)->
                if resp.body.data.import_configuration_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.import_configuration_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.import_configuration_form_mutation.errors
                    self.errors = resp.body.data.import_configuration_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    # console.log "ERROR FORMATED ", self.errors
                    n.form_error()
                else
                    self.errors = {}
                    self.get_import_configurations(resp.body.data.import_configuration_form_mutation.form_ret)
                    self.configuration.name = ''
                    n.success()
            .catch (resp)->
                n.catch_error(resp, "imports_configuration: save_configuration()")
            return

        do_import: (db_save)->
            # import_name = @item+"_import"
            # console.log "DO IMPORT", settings.imports
            # console.log "DO IMPORT", db_save
            self = @
            @db_save = db_save

            tmp_fields = {}
            for f of d[@item]['fields']
                index = @configuration.fields.indexOf(f)
                if @configuration.fields.indexOf(f, index+1) > -1
                    n.error('Importer les données', 'Deux colonnes ne peuvent avoir le même nom')
                    return
                else
                    if index != -1
                        tmp_fields[f] = index
                    else
                        tmp_fields[f] = 'None'

            if @connect == '' and @item == 'users'
                err = {}
                err['connect'] = ['Ce champ est obligatoire']
                @errors = err
                n.form_error()
                return

            @errors = {}
            # console.log "TMP FIELDS ", tmp_fields
            @configuration.fields_index = tmp_fields
            @$http.post(settings.imports, {"import_uid": @uid, "configuration": @configuration, "company_uid":@company_uid, "connect":@connect, "db_save": db_save})
            .then (resp)->
                self.dialog_visible = true
                # console.log "IMPORT OK ", resp.body
                # console.log "IMPORT OK ERRORS ", resp.body.errors
                # console.log "IMPORT OK WARNINGS ", resp.body.warnings
                # console.log "IMPORT OK log_file_dir", resp.body.log_file_dir
                if Object.keys(resp.body.errors).length > 0
                    self.import_errors = resp.body.errors
                    self.import_success = false
                    self.log_file_dir = resp.body.log_file_dir
                    # n.warning("Certaines lignes n'ont pas été importées.")
                if Object.keys(resp.body.warnings).length > 0
                    self.import_warnings = resp.body.warnings
                    self.import_success = false
                    self.log_file_dir = resp.body.log_file_dir
                    # n.warning("Certaines lignes ont été importées de manière incomplète.")
                if Object.keys(resp.body.errors).length == 0
                    self.import_errors = {}
                if Object.keys(resp.body.warnings).length == 0
                    self.import_warnings = {}
                if Object.keys(resp.body.errors).length == 0 and Object.keys(resp.body.warnings).length == 0
                    self.import_success = true
                    # n.success("L'import a été réalisé avec succès")
            return

        get_import_configurations: (new_configuration_uid)->
            self = @
            # console.log "GET IMPORT CONFIGURATIONS ", @item
            q.run('get_import_configuration_set', [@company_uid, @item])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("imports_configuration: get_import_configurations: then", e.message)
                else
                    # console.log "GET imports_configuration : ", resp.body.data.import_configuration_set
                    self.configuration_set = resp.body.data.import_configuration_set
                    if new_configuration_uid?
                        for ic, index in self.configuration_set
                            # console.log "AFTER SAVE ", ic, index, new_configuration_uid
                            if ic.uid == new_configuration_uid
                                self.selected_configuration = index
                                break
            .catch (resp)->
                n.catch_error(resp, "imports_configuration: get_import_configurations()")
            return

        get_import_first_lines: ()->
            # console.log "GET IMPORT FIRST LINES ", @uid
            self = @
            @$http.post(settings.import_first_lines, {"import_uid": @uid, "company_uid":@company_uid})
            .then (resp)->
                if resp.body.status == "ok"
                    # console.log "GET FIRST LINES ", resp.body
                    self.import_first_lines = resp.body.datas.lines
                    self.delete_all = resp.body.datas.delete_all
                    if resp.body.datas.lines.length > 0
                        if resp.body.datas.lines[0].length > 0
                            # console.log "COLUMNS COUNT", resp.body.datas.lines[0].length
                            self.columns_count = resp.body.datas.lines[0].length
                            self.tables_count = Math.ceil(resp.body.datas.lines[0].length / 6)
                            # console.log "TABLES COUNT", self.tables_count
                    self.configuration_fields_factory()
                else if resp.body.status == "wrong_codec"
                    n.warning("Impossible de lire le fichier d'import", "Avez-vous enregistré le bon encodage ? Pour le vérifier, retournez sur la page des imports. Puis, choisissez parmi les imports précédents votre fichier. Enfin, modifiez l'encodage. Et cliquez sur 'Étape suivante'")
                else if resp.body.status == "no_such_file"
                    n.warning("Fichier d'import inconnu...")
                else
                    n.error("imports_configuration: get_import_first_lines: then", resp.body.message)
            return

    beforeMount: ()->
        if @uid in [undefined, null] or @item in [undefined, null]
            @$router.push({name:'imports'})
            .catch (err)-> {}
            return
        # console.log "IMPORT CONFIGURATION BEFORE MOUNT", @uid
        # console.log "IMPORT CONFIGURATION BEFORE MOUNT 2", d[@item]['fields']
        # console.log "IMPORT CONFIGURATION BEFORE MOUNT 3", Object.keys(d[@item]['fields']).length
        # console.log "IMPORT CONFIGURATION BEFORE MOUNT 4", Object.keys(d[@item]['fields'])[0]
        # console.log "IMPORT CONFIGURATION BEFORE MOUNT 5", Object.values(d[@item]['fields'])[0]['label']
        @get_import_configurations()
        @get_import_first_lines()
        # console.log "IMPORT CONFIGURATION BEFORE MOUNT 6", @columns_count
}
